import React from 'react';
import {Form, FormGroup, Input, Label, Row, Col} from 'reactstrap';
import Select from 'react-select';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify'
import Loader from '../Loader';
import MyProfile from './MyProfile';
import ButtonComponent from '../PersonalHealthRecord/ButtonComponent';
import { getAccountDetails, editUserSetting } from '../services'

const lifeStageOptions = [
  { label: "Adolescent", value: 1 },
  { label: "Just Married", value: 2 },
  { label: "Trying to concieve", value: 3 },
  { label: "Pregnant", value: 4 },
  { label: "Already a mother", value: 5 },
  { label: "Beyond 45", value: 6 }
]

const accountForOptions = [
  { label: "Myself", value: 1 },
  { label: "Spouse", value: 2 },
  { label: "Relative", value: 3 }
]

class AccountSetting extends React.Component{

  state = {
    loading: true,
    email: '',
    phone: '',
    addlPhone: '',
    stage: '',
    account: ''
  }

  async componentDidMount() {
    const response = await getAccountDetails();

    const { setting } = response.data; 

    this.setState(prevState => ({
      loading: false,
      name: setting.name,
      email: setting.email,
      phone: setting.mobile,
      addlPhone: setting.addlPhone,
      profilePic: setting.image,
      stage: setting.lifeStage,
      account: setting.accountFor,
    }))
  }

  handleInputChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(prevState => ({
      [name]: value
    }));
  }

  handleStageChange = (selectedOption) => {
    
    this.setState(prevState => ({
      stage: selectedOption['value']
    })) 
  }

  handleAccountChange = (selectedOption) => { 
  
    this.setState(prevState => ({
      account: selectedOption['value']
    }))
  
  }


  handleSubmit = async (event) => {
    
    event.preventDefault();

    const { stage, account, addlPhone } = this.state

    let data = {
      stage: stage,
      account: account,
      addlPhone: addlPhone
    }

    console.log(data);

    const response = await editUserSetting(data);
    
    if(response.status !== 200) {
      toast.error()
    }

    toast.success(response.data.message);
    console.log(this.props);
    this.props.changeLifeStage(stage['value'])

  }

  render(){
    
    if(this.state.loading == true) {
      return (
        <Loader />
      )
    }

    const { name, email, phone, addlPhone, stage, account, profilePic } = this.state;
    console.log(phone)
    return(
        <div className="mt-4">
          <MyProfile
            username={name}
            profilePicture={profilePic}
            showLinks={false}
          />
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col xs="12" md={{size:4}}>
                <FormGroup>
                  <Label>Email Id</Label>
                  <Input type="email" 
                    name="email" 
                    value={email}
                    onChange={this.handleInputChange}
                    disabled>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" md={{size:4}}>
                <FormGroup>
                  <Label>Phone No.</Label>
                  <Input type="text" 
                    name="phone" 
                    value={phone}
                    onChange={this.handleInputChange}
                    disabled>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" md={{size:4}}>
                <FormGroup>
                  <Label>Additional Phone No.(Optional)</Label>
                  <Input type="text"
                    name="addlPhone"
                    value={addlPhone}
                    onChange={this.handleInputChange}
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="4">
                <FormGroup>
                  <Label>Account created for</Label>
                  <Select 
                    options={accountForOptions}
                    onChange={this.handleAccountChange}
                    value={account !== 0 && accountForOptions.filter(option => option.value === account)}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" md="4">
                <FormGroup>
                  <Label>Life Stage</Label>
                  <Select
                    options={lifeStageOptions}
                    onChange={this.handleStageChange}
                    value={stage !== 0 && lifeStageOptions.filter(option => option.value === stage)} 
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col className="col-xs-5 col-sm-4">
                <Button type="submit" className="btn btn-primary">Save</Button>
              </Col>
            </Row>
          </Form>
          {/* <ButtonComponent/> */}
        </div>
    );
  }
}


export default AccountSetting;


// WEBPACK FOOTER //
// ./src/views/Account/AccountSetting.js